import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: "sc_video_upload"
};
const _hoisted_2 = {
    class: "sc_video_upload-input"
};
const _hoisted_3 = {
    class: "sc_video_upload-group"
};
const _hoisted_4 = {
    class: "sc_video_upload-progress"
};
const _hoisted_5 = {
    key: 0,
    class: "sc_video_upload-label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_button = _resolveComponent("el-button");
    const _component_el_progress = _resolveComponent("el-progress");
    return _openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("input", {
                type: "file",
                id: "fileUpload",
                accept: "video/*",
                onChange: _cache[0] || (_cache[0] = ($event)=>$options.fileChange($event))
            }, null, 32),
            _createTextVNode(" 上传状态：" + _toDisplayString($data.statusText), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: $options.stsUpload,
                disabled: $data.uploadDisabled
            }, {
                default: _withCtx(()=>[
                        ..._cache[1] || (_cache[1] = [
                            _createTextVNode("开始上传", -1)
                        ])
                    ]),
                _: 1
            }, 8, [
                "onClick",
                "disabled"
            ]),
            _createVNode(_component_el_button, {
                size: "small",
                onClick: $options.pauseUpload,
                disabled: $data.pauseDisabled
            }, {
                default: _withCtx(()=>[
                        ..._cache[2] || (_cache[2] = [
                            _createTextVNode("暂停", -1)
                        ])
                    ]),
                _: 1
            }, 8, [
                "onClick",
                "disabled"
            ]),
            _createVNode(_component_el_button, {
                size: "small",
                disabled: $data.resumeDisabled,
                onClick: $options.resumeUpload
            }, {
                default: _withCtx(()=>[
                        ..._cache[3] || (_cache[3] = [
                            _createTextVNode("恢复上传", -1)
                        ])
                    ]),
                _: 1
            }, 8, [
                "disabled",
                "onClick"
            ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "sc_video_upload-label"
        }, " 上传进度： ", -1)),
        _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_progress, {
                percentage: $data.stsProgress,
                status: $data.stsProgress === 100 && 'success',
                striped: "",
                "striped-flow": ""
            }, null, 8, [
                "percentage",
                "status"
            ])
        ]),
        $props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 当前已上传视频ID：" + _toDisplayString($props.modelValue), 1)) : _createCommentVNode("", true)
    ]);
}
